export default "__VITE_ASSET__44405b5b__"